<template>
  <div>
    <div shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="门店仓库">
          <customer-store-select
            :defaultFirst="true"
            style="width: 206px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
      </el-form>
    </div>
    <div
      shadow="hover"
      style="min-height: 150px"
      v-loading="!pageData && loading"
    >
      <div v-if="storeGuid">
        <div style="padding: 10px" v-if="pageData">
          <div style="margin-bottom: 5px">
            <el-button type="primary" @click="createClick">
              新建云打印机
            </el-button>
            <el-button @click="refreshList" :loading="pageData && loading">
              刷新
            </el-button>
          </div>
          <el-table ref="table" :data="pageData" row-key="guid">
            <el-table-column prop="name" label="打印机名称" min-width="220">
              <template slot-scope="scope">
                <span style="color: #333333">
                  {{ scope.row.name }}
                </span>
                <span
                  v-if="scope.row.desc"
                  style="color: #919191; margin-left: 5px"
                >
                  {{ scope.row.desc }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="printerType" label="打印机类型" width="150">
            </el-table-column>
            <el-table-column prop="printerSn" label="打印机编号" width="150">
            </el-table-column>
            <el-table-column prop="flagPrintOrder" label="订单小票" width="100">
            </el-table-column>
            <el-table-column prop="flagPrintSplit" label="拆零标签" width="100">
            </el-table-column>
            <el-table-column prop="optSort" label="排序编号" width="100">
            </el-table-column>
            <el-table-column prop="optStatus" label="设备状态" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.optStatus == 1" style="color: #67c23a">
                  在线-正常
                </span>
                <span
                  v-else-if="scope.row.optStatus == 2"
                  style="color: #e6a23c"
                >
                  在线-异常
                </span>
                <span
                  style="color: #ff0000"
                  v-else-if="scope.row.optStatus == 3"
                  @click="failureMsgClick(scope.row)"
                >
                  出错了
                </span>
                <span v-else style="color: #ff0000"> 离线 </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="操作"
              width="180"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-link type="primary" @click="editClick(scope.row)">
                  编辑
                </el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link type="primary" @click="queryClick(scope.row)">
                  刷新状态
                </el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link type="danger" @click="deleteClick(scope.row)">
                  删除
                </el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-empty
          v-else-if="!loading"
          :description="errorMsg"
          :image-size="100"
        >
          <el-button v-if="errorMsg" @click="refreshList" size="small">
            重新加载
          </el-button>
        </el-empty>
      </div>
      <el-empty v-else description="请选择门店" :image-size="100"> </el-empty>
    </div>
  </div>
</template>

<script>
import formPage from "./__store_printer_form.vue";
import failureMsgPage from './__store_printer_failure_msg.vue';
import customerStoreSelect from '../../../../components/business/customerStoreSelect.vue';

export default {
  components: {
    customerStoreSelect
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    defaultParams() {
      return Object.assign({
        storeGuid: this.storeGuid,
      }, this.queryModel || {});
    },
    pageParams() {
      return Object.assign({},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign({},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      pageData: null,
      storeGuid: "",
      queryModel: {},
      formInline: {},
    };
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
      this.refreshList();
    }
  },
  methods: {
    clearClick() {
      this.formInline = {
        queryValue: ""
      }
      this.queryModel = {};
    },
    queryClick() {
      this.queryModel = Object.assign({
      }, this.formInline);
    },
    failureMsgClick(printerInfo) {
      this.$drawer.openDrawer({
        title: '错误日志记录',
        component: failureMsgPage,
        params: printerInfo,
      }, true);
    },
    editClick(row) {
      this.$drawer.openDrawer({
        title: "编辑云打印机",
        component: formPage,
        refresh: this.refreshList,
        params: {
          storeGuid: row.storeGuid,
          guid: row.guid
        },
      }, true);
    },
    queryClick(row) {
      this.requestApi("biz.customer.store.printer.query", {
        guid: row.guid,
        storeGuid: row.storeGuid,
      }, { showError: true }).then(() => {
        this.refreshList();
        this.$drawer.refreshDrawer();
        this.success("刷新成功");
      });
    },
    deleteClick(row) {
      this.$confirm("确定删除?", "提示", {
        type: "warning",
      }).then(() => {
        this.requestApi("biz.customer.store.printer.delete", {
          guid: row.guid,
          storeGuid: row.storeGuid,
        }, { showError: true }).then(() => {
          this.refreshList();
          this.$drawer.refreshDrawer();
          this.success("删除成功");
        });
      });
    },
    createClick() {
      this.$drawer.openDrawer({
        title: "新建云打印机",
        component: formPage,
        refresh: this.refreshList,
        params: {
          storeGuid: this.storeGuid
        },
      }, true);
    },
    refreshList() {
      if (this.storeGuid) {
        this.errorMsg = null;
        this.loading = true;
        return this.requestApi("biz.customer.store.printer.list",
          this.defaultParams).then((resp) => {
            this.loading = false;
            this.pageData = (resp.data.list || []).map(item => {
              return Object.assign({ hasChildren: item.childrenCount > 0 }, item)
            });
          }).catch((err) => {
            this.loading = false;
            this.errorMsg = (err && (err.msg || err.message))
              || "连接服务器失败，请检查网络";
          });
      } else {
        this.errorMsg = null;
        this.loading = false;
        this.pageData = null;
      }
    },
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
    this.refreshList();
  },
};
</script>